'use strict';

Object.defineProperty(exports, "__esModule", {
      value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Microwave = function (_React$Component) {
      _inherits(Microwave, _React$Component);

      function Microwave() {
            _classCallCheck(this, Microwave);

            return _possibleConstructorReturn(this, (Microwave.__proto__ || Object.getPrototypeOf(Microwave)).apply(this, arguments));
      }

      _createClass(Microwave, [{
            key: 'render',
            value: function render() {
                  return _react2.default.createElement(
                        Svg,
                        { width: '26', height: '32', viewBox: '0 0 26 32' },
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M21.755 24.794h-17.917c-2.117 0-3.839-1.722-3.839-3.839v-11.25c0-2.116 1.722-3.839 3.839-3.839h17.917c2.117 0 3.839 1.722 3.839 3.839v11.25c0 2.117-1.722 3.839-3.839 3.839zM3.838 6.934c-1.528 0-2.772 1.243-2.772 2.772v11.25c0 1.529 1.244 2.772 2.772 2.772h17.917c1.529 0 2.772-1.243 2.772-2.772v-11.25c0-1.529-1.243-2.772-2.772-2.772h-17.917z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M19.4 21.774h-15.345c-0.294 0-0.533-0.238-0.533-0.533v-11.95c0-0.294 0.239-0.533 0.533-0.533h15.345c0.295 0 0.533 0.239 0.533 0.533v11.95c0 0.295-0.238 0.533-0.533 0.533zM4.588 20.708h14.279v-10.883h-14.279v10.883z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M22.007 11.279c-0.295 0-0.533-0.239-0.533-0.533v-0.995c0-0.294 0.238-0.533 0.533-0.533s0.533 0.239 0.533 0.533v0.995c0 0.294-0.238 0.533-0.533 0.533z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M22.007 14.505c-0.295 0-0.533-0.239-0.533-0.533v-0.995c0-0.294 0.238-0.533 0.533-0.533s0.533 0.239 0.533 0.533v0.995c0 0.294-0.238 0.533-0.533 0.533z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M22.007 17.73c-0.295 0-0.533-0.238-0.533-0.533v-0.996c0-0.294 0.238-0.533 0.533-0.533s0.533 0.239 0.533 0.533v0.996c0 0.295-0.238 0.533-0.533 0.533z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M5.737 26.133c-0.294 0-0.533-0.238-0.533-0.533v-1.035c0-0.295 0.239-0.533 0.533-0.533s0.533 0.238 0.533 0.533v1.035c0 0.295-0.239 0.533-0.533 0.533z' }),
                        _react2.default.createElement(Path, { fill: this.props.fill,
                              d: 'M19.855 26.133c-0.295 0-0.533-0.238-0.533-0.533v-1.035c0-0.295 0.238-0.533 0.533-0.533s0.533 0.238 0.533 0.533v1.035c0 0.295-0.238 0.533-0.533 0.533z' })
                  );
            }
      }]);

      return Microwave;
}(_react2.default.Component);

Microwave.propTypes = {
      fill: _react2.default.PropTypes.string
};

exports.default = Microwave;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/microwave.js
// module id = 1113
// module chunks = 0